import api from './axios';

// Get ticket details (role-aware)
export const getTicketDetails = async (ticketId, role = 'agent') => {
  let endpoint = `/agent/ticket/${ticketId}`;
  
  if (role === 'manager') {
    endpoint = `/manager/ticket/${ticketId}`;
  } else if (role === 'team_lead') {
    endpoint = `/team-lead/ticket/${ticketId}`;
  }
  
  const response = await api.get(endpoint);
  return response.data;
};

// Update ticket (role-aware)
export const updateTicket = async (ticketId, data, role = 'agent') => {
  let endpoint = `/agent/ticket/${ticketId}/update`;
  
  if (role === 'manager') {
    endpoint = `/manager/ticket/${ticketId}/update`;
  } else if (role === 'team_lead') {
    endpoint = `/team-lead/ticket/${ticketId}/update`;
  }
  
  const response = await api.put(endpoint, data);
  return response.data;
};

// Add comment (role-aware)
export const addTicketComment = async (ticketId, message, attachment = null, role = 'agent') => {
  let endpoint = `/agent/ticket/${ticketId}/comment`;
  
  if (role === 'manager') {
    endpoint = `/manager/ticket/${ticketId}/comment`;
  } else if (role === 'team_lead') {
    endpoint = `/team-lead/ticket/${ticketId}/comment`;
  }
  
  const response = await api.post(endpoint, { message, attachment });
  return response.data;
};

// Reassign ticket
export const reassignTicket = async (ticketId, agentId, role = 'team_lead') => {
  let endpoint = `/team-lead/ticket/${ticketId}/reassign`;
  
  if (role === 'manager') {
    endpoint = `/manager/ticket/${ticketId}/reassign`;
  }
  
  const response = await api.put(endpoint, { agent_id: agentId });
  return response.data;
};

// Get available agents (for reassignment)
export const getAvailableAgents = async (role = 'team_lead') => {
  let endpoint = '/team-lead/team-members';
  
  if (role === 'manager') {
    endpoint = '/manager/agents';
  }
  
  const response = await api.get(endpoint);
  return response.data;
};

// Agent: Get my tickets
export const getMyTickets = async (status = null) => {
  const params = status ? { status } : {};
  const response = await api.get('/agent/my-tickets', { params });
  return response.data;
};

// Team Lead: Get team tickets
export const getTeamTickets = async (status = null) => {
  const params = status ? { status } : {};
  const response = await api.get('/team-lead/team-tickets', { params });
  return response.data;
};

// Manager: Get all tickets
export const getAllTickets = async (status = null) => {
  const params = status ? { status } : {};
  const response = await api.get('/manager/tickets', { params });
  return response.data;
};
// Upload attachment
export const uploadAttachment = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  
  const response = await api.post('/upload-attachment', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
};

// Get related tickets
export const getRelatedTickets = async (ticketId) => {
  const response = await api.get(`/tickets/related/${ticketId}`);
  return response.data;
};
// Manager: Create new ticket
export const createTicket = async (ticketData) => {
  const response = await api.post('/manager/ticket/create', ticketData);
  return response.data;
};
